import AttachFileIcon from '@mui/icons-material/AttachFile';
import CommentIcon from '@mui/icons-material/Comment';
import EditIcon from '@mui/icons-material/Edit';
import { Badge, IconButton } from '@mui/material';

import { FormLayoutBuilder, getFormData } from '@pihealth/common-ui-library';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import DARDocUpload from 'src/components/StartUp/documentUpload/DARDocUpload';
import Notes from 'src/components/common/Notes';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import AppModal from 'src/components/modal';
import { useGetCodeListDataQuery } from 'src/services/codeList';
import { useAppSelector } from 'src/store';
import { setMessage } from 'src/store/Message';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import forms from '../../../../../resources/forms.json';
import { useCommonDrugAccountability } from '../useCommonDrugAccountability';
import { archLevel } from 'src/data/config';
import { DataTable } from '@pihealth/common-ui-library';
import { GridToolbarExport } from '@mui/x-data-grid-pro';

const Received: React.FunctionComponent<any> = ({ kitData, recivedPopupEvent, setRecivedPopupEvent }: any) => {
  const { user } = useUser();
  const formGroup = forms.DARRecivedAddKit;
  const [codes, setCodes] = useState<any>({});
  const { formFields, defaultValues = {}, rules } = getFormData(formGroup.groups, codes);
  const { groups } = formFields;
  const formRef: any = useRef(null);
  const {
    updateDARDoc,
    createDARNotes,
    getDARNotes,
    getDrugEventRecords,
    getDrugEventRecordsLoading,
    createDrugEventRecords,
    updateDrugEventRecords
  } = useCommonDrugAccountability();
  const [onEdit, setOnEdit] = useState(false);
  const [pageSize, setPageSize] = React.useState(10);
  const currentAppName = archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_TSDA_SLUG;
  const [rowsCount, setRowsCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [filterObject, setFilterObject] = useState<any>();
  const dispatch = useDispatch();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const [updateEditData, setUpdateEditData] = useState<any>({});
  const [rows, setRows] = useState<any>({});
  const [id, setID] = useState('');
  const [progress, setProgress] = useState(false);
  const [commentDilogOpen, setCommentDilogOpen] = useState(false);
  const [uploadDilogOpen, setUploadDilogOpen] = useState<boolean>(false);
  const [uploadedFiles, setUploadedFiles] = useState<any>([]);
  const [progressDocUpload, setProgressDocUpload] = useState<boolean>(false);
  const [notesData, setNotesData] = useState([]);
  const [notetext, setNoteText] = useState('');
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const { duFileUploadErrorMsg, duDocumentUploadSuccessMsg } = useFieldTranslation();
  const { checkPermission } = usePermissionWrapper();
  const { data: unitList } = useGetCodeListDataQuery('IPKUNIT');
  const documentMetaData = {
    name: 'Drug accountability log',
    number: '10.03.06'
  };
  useEffect(() => {
    if (unitList) {
      const data: any = unitList;
      const tempArr = data.map((ele: any) => {
        return {
          displayName: ele.code_list_value,
          key: ele.code_list_value
        };
      });
      if (!codes?.IPKUNIT?.length) {
        setCodes({ ...codes, IPKUNIT: tempArr });
      }
    }
  }, [unitList]);
  useEffect(() => {
    getAllDrugEventsData(0, 10);
  }, []);
  useEffect(() => {
    if (!getDrugEventRecordsLoading && (pageSize === 10 || pageSize === 20 || pageSize === 30)) {
      if (pageNumber * pageSize > rowsCount - 1) {
        setPageNumber(0);
        getAllDrugEventsData(0, pageSize);
      } else {
        getAllDrugEventsData(pageNumber * pageSize, pageSize);
      }
    }
  }, [pageNumber, pageSize]);

  useEffect(() => {
    if (filterObject) {
      getAllDrugEventsData(0, pageSize);
    }
  }, [filterObject]);
  const handleEdit = (row_data: any) => {
    setID('');
    setUpdateEditData({ ...row_data, updated_by: user });
    setID(row_data.id);
    setOnEdit(true);
    setRecivedPopupEvent(true);
  };
  const handleSendNote = async () => {
    if (notetext !== '') {
      sendNotesData(id);
      setNoteText('');
    }
  };
  const sendNotesData = async (id: string) => {
    try {
      await createDARNotes({
        event_id: id,
        data: {
          da_log_kit_notes: notetext,
          created_by: user
        },
        country: selectedCountry,
        application: process.env.REACT_APP_NAME,
        site_id: selectedSite
      });
    } catch (error: any) {
      if (error && error?.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error && error.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
    }
    getNotesData(id);
  };
  const getNotesData = async (id: any) => {
    try {
      const res: any = await getDARNotes({ event_id: id });
      const result = res?.data;
      setNotesData(result);
    } catch (error: any) {
      if (error && error?.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error && error.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
      setNotesData([]);
    }
  };
  const handleComment = (row: any) => {
    setNotesData([]);
    setID('');
    setCommentDilogOpen(true);
    getNotesData(row.id);
    setID(row.id);
  };
  const formatDate = (params: any) => {
    return moment(params.row.da_log_kit_date_time).format(`${userPreferedDateFormat.toUpperCase()} h:mm A`);
  };
  const handleFileUploadOpen = (row: any) => {
    setID(row.id);
    setUploadedFiles([...row.documents_data]);
    setUploadDilogOpen(true);
  };
  const updateDocs = async (updatedDocIds: string[], isDocDelete = false) => {
    setProgressDocUpload(true);
    try {
      await updateDARDoc({
        event_id: id,
        data: {
          uploaded_file_ids: updatedDocIds
        },
        country: selectedCountry,
        application: process.env.REACT_APP_NAME
      });
      if (isDocDelete) {
        dispatch(setMessage({ msgDetails: 'Document Deleted successfuly', severity: 'success' }));
      } else {
        dispatch(setMessage({ msgDetails: duDocumentUploadSuccessMsg, severity: 'success' }));
      }
    } catch (error: any) {
      if (error && error?.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error && error.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      } else if (isDocDelete) {
        dispatch(setMessage({ msgDetails: 'Error in Document Delete', severity: 'success' }));
      } else {
        dispatch(setMessage({ msgDetails: duFileUploadErrorMsg, severity: 'error' }));
      }
    }
    setProgressDocUpload(false);
    setUploadDilogOpen(false);
    getAllDrugEventsData(pageNumber * pageSize, pageSize);
    setID('');
  };
  const columns = [
    {
      field: 'da_log_kit_date_time',
      headerName: 'Received Date',
      flex: 1,
      type: 'date',
      valueGetter: formatDate
    },
    {
      field: 'da_log_kit_quantity',
      headerName: 'Received Quantity',
      flex: 1,
      type: 'number'
    },
    {
      field: 'da_log_kit_shipment_id',
      headerName: 'Shipment ID',
      flex: 1
    },
    {
      field: 'da_log_kit_temp_receipt',
      headerName: 'Temperature at Receipt',
      flex: 1
    },
    {
      field: 'da_log_kit_balance_forward',
      headerName: 'Balance Forward',
      flex: 1,
      type: 'number'
    },
    {
      field: 'da_log_kit_initials',
      headerName: "Recorder's initials",
      flex: 1
    },
    {
      field: 'action',
      headerName: 'Action',
      minWidth: 90,
      flex: 1,
      disableExport: true,
      filterable: false,
      renderCell: (params: any) => (
        <>
          <IconButton sx={{ mr: 0.5 }} onClick={() => handleFileUploadOpen(params.row)} title="Attach File">
            <AttachFileIcon color="primary" />
            <Badge badgeContent={params.row.docCount} color="primary" className="smallBadgeSearch" sx={{ mt: -2.5 }} />
          </IconButton>
          <IconButton onClick={() => handleComment(params.row)} title="Comment">
            <CommentIcon sx={{ color: '#2196F3' }} />
          </IconButton>
          {checkPermission('update_kit_received_event') ? (
            <IconButton onClick={() => handleEdit(params.row)} title="Edit">
              <EditIcon />
            </IconButton>
          ) : (
            <></>
          )}
        </>
      )
    }
  ];

  const handleCancelAddEvent = () => {
    setRecivedPopupEvent(false);
    setOnEdit(false);
  };

  const getAllDrugEventsData = async (from: number, size: number) => {
    setProgress(true);
    const result: any = await getDrugEventRecords({
      site_id: selectedSite,
      study_id: studyId,
      kit_id: kitData.da_log_kit_id,
      data: filterObject,
      country: selectedCountry,
      application: currentAppName,
      da_log_kit_event: 'Received',
      from,
      size
    });
    if (result?.isSuccess) {
      let updated = [];
      if (result.data && result.data.selected_data.length > 0) {
        setRowsCount(result?.data.record_count);
        updated = result?.data.selected_data.map((item: any) => {
          return {
            id: item.event_data.id,
            documents_data: item.file_ids,
            docCount: item.file_ids.length,
            ...item.event_data
          };
        });
      } else {
        setRowsCount(0);
      }
      setRows(updated);
    } else if (result?.isError) {
      setRows([]);
      setRowsCount(0);
      if (result.error?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (result.error?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
    }
    setProgress(false);
  };
  const handleAddReceived = async (data: any) => {
    await createDrugEventRecords({
      site_id: selectedSite,
      study_id: studyId,
      kit_id: kitData.da_log_kit_id,
      data: { ...data, da_log_kit_event: 'Received', created_by: user },
      country: selectedCountry,
      application: process.env.REACT_APP_NAME
    });
    setRecivedPopupEvent(false);
    getAllDrugEventsData(0, pageSize);
  };
  const handleEditRecived = async (data: any) => {
    if (
      updateEditData.da_log_kit_date_time === data.da_log_kit_date_time &&
      updateEditData.da_log_kit_quantity === data.da_log_kit_quantity &&
      updateEditData.da_log_kit_quantity_unit === data.da_log_kit_quantity_unit &&
      updateEditData.da_log_kit_shipment_id === data.da_log_kit_shipment_id &&
      updateEditData.da_log_kit_balance_forward === data.da_log_kit_balance_forward &&
      updateEditData.da_log_kit_temp_receipt === data.da_log_kit_temp_receipt
    ) {
      dispatch(setMessage({ msgDetails: 'No change in data and hence cannot save the information', severity: 'info' }));
      setUpdateEditData({});
      setRecivedPopupEvent(false);
      setOnEdit(false);
    } else {
      try {
        await updateDrugEventRecords({
          id,
          data: { ...data, updated_by: user },
          country: selectedCountry,
          application: process.env.REACT_APP_NAME
        });
        dispatch(setMessage({ msgDetails: 'Data update successfully', severity: 'success' }));
      } catch (error: any) {
        if (error && error?.response?.status === 403) {
          dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
        } else if (error && error.response?.status === 401) {
          dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
        } else {
          dispatch(setMessage({ msgDetails: 'Error while adding Data', severity: 'error' }));
        }
      }
      setUpdateEditData({});
      setRecivedPopupEvent(false);
      getAllDrugEventsData(pageNumber * pageSize, pageSize);
      setOnEdit(false);
    }
  };

  const handleSubmit = () => {
    formRef.current.submit(onFormSubmit);
  };
  const onFormSubmit = (data: any) => {
    if (data.errors) {
      return;
    }
    if (data.success) {
      if (onEdit) {
        handleEditRecived({
          ...data.records,
          da_log_kit_date_time: moment(data.records.da_log_kit_date_time).utcOffset(0, true).format()
        });
      } else {
        handleAddReceived({
          ...data.records,
          da_log_kit_date_time: moment(data.records.da_log_kit_date_time).utcOffset(0, true).format()
        });
      }
    }
  };
  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `Drug Accountability Record-Received ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };
  const dataTableProps = {
    filterMode: 'server'
  };
  const filterValues = (data: any) => {
    setFilterObject(data);
  };

  return (
    <div>
      <DataTable
        height="66vh"
        hasDefinedColumns
        hasDefinedDataGridToolbarExport
        definedGridToolbarExport={definedCustomDatGridExport}
        columns={columns}
        rows={rows}
        loading={progress}
        exportCSVName={`Drug Accountability Record-Received`}
        datePreference={userPreferedDateFormat}
        paging
        pageSize={pageSize}
        setPageSize={setPageSize}
        rowsCount={rowsCount}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        paginationMode="server"
        dataTableProps={dataTableProps}
        filterValues={(data: any) => filterValues(data)}
      />
      <AppModal
        open={recivedPopupEvent}
        title={formGroup.header}
        handleSubmit={handleSubmit}
        handleClose={handleCancelAddEvent}
      >
        <FormLayoutBuilder
          isDisableRule
          initialValues={onEdit ? updateEditData : defaultValues}
          rules={rules}
          ref={formRef}
          groups={groups}
          columnSpacing={2}
        />
      </AppModal>
      <Notes
        commentDilogOpen={commentDilogOpen}
        setCommentDilogOpen={setCommentDilogOpen}
        notesData={notesData}
        handleSendNote={handleSendNote}
        notetext={notetext}
        setNoteText={setNoteText}
        permission={checkPermission('update_kit_received_event')}
      />
      <DARDocUpload
        documentMetaData={documentMetaData}
        uploadDilogOpen={uploadDilogOpen}
        setUploadDilogOpen={setUploadDilogOpen}
        uploadedFiles={uploadedFiles}
        updateDocs={updateDocs}
        progress={progressDocUpload}
        permission={checkPermission('update_kit_received_event')}
      />
    </div>
  );
};

export default Received;
